export const BILLING_TRANSFER_PENDING = "billing_transfer_pending";
export const BILLING_OWNER_RESOLVED = "billing_owner_resolved";
export const SOLO_RETAINED_BILLING = "solo_retained_billing";
export const COACH_ASSUMED_BILLING = "coach_assumed_billing";

export const KEEP_SOLO_BILLING = "keep_solo_billing";
export const TRANSFER_TO_COACH = "transfer_to_coach";
export const DECLINE_LINKAGE = "decline_linkage";
export const DEFER_BILLING_TRANSFER = "defer";

export const BILLING_OWNERSHIP_PENDING_STATUSES = ["pending"] as const;
export const BILLING_OWNERSHIP_RESOLVED_STATUSES = ["resolved"] as const;

export type BillingOwnershipState =
  | typeof BILLING_TRANSFER_PENDING
  | typeof BILLING_OWNER_RESOLVED
  | typeof SOLO_RETAINED_BILLING
  | typeof COACH_ASSUMED_BILLING;

export type BillingResolutionAction =
  | typeof KEEP_SOLO_BILLING
  | typeof TRANSFER_TO_COACH
  | typeof DECLINE_LINKAGE
  | typeof DEFER_BILLING_TRANSFER;

export function buildLeaderBillingPendingCopy(): string {
  return "Your coach connection is being set up. Your individual billing will not change unless you approve or a transfer is completed.";
}

export function buildCoachBillingPendingCopy(): string {
  return "This leader already has an individual paid plan. Resolve billing before this leader is added to your active leader billing.";
}
